/**
 * Constantes para IDs de empresas especiales
 * Aquí se definen los IDs de empresas que tienen comportamientos específicos
 */

export const SPECIAL_CLIENT_IDS = {
  // Terra Club SRL - Cliente con prioridad por defecto "1"
  TERRA_CLUB: 1774,
  
  // Cliente con ID 2165 - Cliente con prioridad por defecto "0"
  CONSEJO_DEL_MENOR: 2165,
  
  // Agregar aquí otros clientes especiales en el futuro
  // EJEMPLO: ANOTHER_SPECIAL_CLIENT: 9999,
} as const;

/**
 * Tipos para las constantes de clientes especiales
 */
export type SpecialClientId = typeof SPECIAL_CLIENT_IDS[keyof typeof SPECIAL_CLIENT_IDS];

/**
 * Función helper para verificar si un cliente ID es especial
 */
export const isSpecialClient = (clientId: number | undefined): boolean => {
  if (!clientId) return false;
  return Object.values(SPECIAL_CLIENT_IDS).includes(clientId as SpecialClientId);
};

/**
 * Función helper para obtener el valor de prioridad por defecto según el cliente
 */
export const getDefaultPriorityValue = (clientId: number | undefined): string => {
  if (clientId === SPECIAL_CLIENT_IDS.TERRA_CLUB) {
    return "1"; // Terra Club SRL tiene prioridad "1" por defecto
  }
  return "0"; // Otros clientes tienen prioridad "0" por defecto
};

/**
 * Función helper para obtener el valor booleano de prioridad por defecto según el cliente
 */
export const getDefaultPriorityBoolean = (clientId: number | undefined): boolean => {
  if (clientId === SPECIAL_CLIENT_IDS.TERRA_CLUB) {
    return true; // Terra Club SRL tiene prioridad true por defecto
  }
  return false; // Otros clientes tienen prioridad false por defecto
};
